import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const ServiceSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    code: Yup.string().nullable(),
    description: Yup.string().nullable(),
});

export default function ServiceUpsertFrom({ service, storeUrl, updateUrl, onSuccess, onCancel }) {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: service?.name || '',
                code: service?.code || '',
                description: service?.description || '',
            }}
            validationSchema={ServiceSchema}
            onSubmit={(values, actions) => {
                if (service?.id) {
                    const url = updateUrl.replace('SERVICE_ID', service.id);
                    axios
                        .put(url, values)
                        .then((res) => {
                            onSuccess();
                            actions.resetForm();
                        })
                        .catch((e) => {
                            e?.response?.data?.errors && actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                } else {
                    axios
                        .post(storeUrl, values)
                        .then((res) => {
                            onSuccess();
                            actions.resetForm();
                        })
                        .catch((e) => {
                            e?.response?.data?.errors && actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }
            }}
        >
            {({ errors, touched, isSubmitting, handleSubmit }) => (
                <>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                        <TextFormField label={$t('Name')} type="text" name="name"></TextFormField>
                        <TextFormField label={$t('Code')} type="text" name="code"></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField label={$t('Description')} as="textarea" type="text" name="description"></TextareaFormField>
                    </div>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={onCancel}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
